import React, { useState } from 'react';

function getInitials(name) {
  if (!name) return '??';
  const parts = name.trim().split(/\s+/);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[1][0]).toUpperCase();
  }
  return name.slice(0, 2).toUpperCase();
}

export default function AdminAvatar({ src, name, className = 'h-8 w-8 text-sm' }) {
  const [imgError, setImgError] = useState(false);

  // If the src is the dummy fallback or empty, show initials
  const isFallback = src === '/images/dummyimg.png' || !src;
  const showInitials = imgError || isFallback;

  if (showInitials) {
    return (
      <div className={`flex items-center justify-center bg-[#F0D9E7] text-[#570033] font-medium rounded-full ${className}`}>
        {getInitials(name)}
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={name}
      onError={() => setImgError(true)}
      className={`rounded-full object-cover ${className}`}
    />
  );
}
